
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database'; // Import getDatabase from firebase/database

const config = {
  apiKey: "AIzaSyDYqsSNAdVzipni4Zj6H0lTxFQz_bTE3XE",
  authDomain: "scta-65c18.firebaseapp.com",
  databaseURL: "https://scta-65c18-default-rtdb.firebaseio.com",
  projectId: "scta-65c18",
  storageBucket: "scta-65c18.appspot.com",
  messagingSenderId: "300565788198",
  appId: "1:300565788198:web:fcce3fafc05706de0718e7",
  measurementId: "G-WN007V665V"
};
const app = initializeApp(config);
// Initialize Firebase services
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);
const db = getDatabase(app); // Initialize the Realtime Database

//console.log("db", db)

const googleAuthProvider = new GoogleAuthProvider();

// firebase.database().ref().set({
//   name: "Jeffrey C. Witt"
// });

export { app, auth, firestore, storage, db, googleAuthProvider};